module.exports = __webpack_public_path__ + "static/img/6.5412f35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fu_shen/6.png
// module id = oSWv
// module chunks = 0